var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cooperation-page"}},[_c('coop-top-panel'),_c('reason-panel'),_c('service-panel'),_c('join-panel'),_c('security-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }